import { createAsyncThunk } from '@reduxjs/toolkit';
import * as API from '../api/index.js';
import { notification } from 'antd';

const mapBalanceUpdateCodeToDescription = (balanceHistory) => {
    const balanceUpdateReasons = [
        '',
        'vacation created',
        'vacation updated',
        'vacation removed',
        'increase via balance changer',
        'decrease via balance changer',
        'monthly increase',
        'monthly decrease',
        'vacation denied',
        'added balance if the created or updated holiday falls on the user’s vacation',
        'removed balance if the removed or updated holiday falls on the user’s vacation',
    ];

    return balanceHistory.map((entry) => ({
        ...entry,
        reasonForChange: balanceUpdateReasons[entry.reasonForChange],
    }));
};

export const fetchBalanceHistory = createAsyncThunk(
    'balance/fetchBalanceHistory',
    async ({ page }, { getState, rejectWithValue }) => {
        try {
            const state = getState();
            const userId = state.user.user.id;

            if (!userId) {
                return rejectWithValue('User not ready');
            }

            const perPage = state.balance.perPage;
            const existing = state.balance.history.balanceHistory;

            const { balanceHistory, maxPageNumber } = await API.user.getBalanceHistory(userId, page, perPage);

            const mappedHistory = mapBalanceUpdateCodeToDescription(balanceHistory);
            return {
                maxPageNumber,
                balanceHistory: page ? [...existing, ...mappedHistory] : mappedHistory,
            };
        } catch (err) {
            return rejectWithValue(err.message || 'Failed to fetch balance history');
        }
    },
);

export const fetchCurrentBalance = createAsyncThunk(
    'balance/fetchCurrentBalance',
    async (_, { getState, rejectWithValue }) => {
        try {
            const userId = getState().user.user.id;

            if (!userId) {
                return rejectWithValue('User not ready');
            }

            const balance = await API.vacations.getBalance(userId);
            return balance;
        } catch (err) {
            return rejectWithValue(err.message || 'Failed to fetch balance');
        }
    },
);

export const updateUserBalance = createAsyncThunk(
    'balance/updateUserBalance',
    async ({ id, payload }, { rejectWithValue }) => {
        try {
            await API.user.updateBalance(id, payload);
            notification.success({
                message: 'Success',
                description: 'Vacation balance changed',
            });
            return { id, ...payload };
        } catch (err) {
            notification.error({
                message: 'Error',
                description: err.message || 'Failed to update balance',
            });
            return rejectWithValue(err.message || 'Failed to update balance');
        }
    },
);
